import { createFileRoute } from "@tanstack/react-router";
import { Construction } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/under_development",
)({
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useTranslation();

	return (
		<div className="min-h-screen flex items-center justify-center bg-base-100">
			<div className="text-center space-y-6 p-8">
				<div className="flex justify-center">
					<div className="bg-warning/10 p-6 rounded-full">
						<Construction className="w-16 h-16 text-warning" />
					</div>
				</div>
				<div className="space-y-2">
					<h1 className="text-4xl font-bold text-base-content">
						{t("common.underDevelopment")}
					</h1>
					<p className="text-base-content/70 text-lg max-w-md mx-auto">
						{t("common.underDevelopmentDescription")}
					</p>
				</div>
				<div className="flex justify-center">
					<div className="loading loading-dots loading-lg text-primary" />
				</div>
			</div>
		</div>
	);
}
